import { render, staticRenderFns } from "./AsideMenuItem.vue?vue&type=template&id=2aadf5ac&"
import script from "./AsideMenuItem.vue?vue&type=script&lang=ts&"
export * from "./AsideMenuItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports